/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Product/ProductUnitsOfMeasureHelper',[
    'jquery',
    'lodash',
    'global/Logger',
    'global/Extensions'
], function ($, _, Logger, Extensions) {
    'use strict';

    var isUnitOfLengthKey = 'isUnitOfLength';
    var baseLengthUnitKey = 'baseLengthUnit';


    /**
     * Determines whether the given unit of measure represents unit of length ("ft", "cm", etc.)
     * @param {} unitOfMeasure 
     * @returns {} 
     */
    function isUnitOfLength(unitOfMeasure) {
        return Extensions.hasCustomFields(unitOfMeasure) &&
            unitOfMeasure.customFields.hasOwnProperty(isUnitOfLengthKey) &&
            unitOfMeasure.customFields[isUnitOfLengthKey] === true;
    }

    /**
     * Returns base unit of length for the given unit of measure
     * "4ft" -> "ft"
     * "12cm" -> "cm"
     * @param {} unitOfMeasure 
     * @returns {} 
     */
    function getBaseLengthUnitFromViewModel(unitOfMeasure) {
        if (Extensions.hasCustomFields(unitOfMeasure) &&
            unitOfMeasure.customFields.hasOwnProperty(baseLengthUnitKey)) {
            return unitOfMeasure.customFields[baseLengthUnitKey];
        } else {
            return null;
        }
    }

    function getUomIdFromTextBox($textbox) {
        if ($textbox === undefined || $textbox === null || !$textbox.jquery || $textbox.length === 0) {
            return null;
        }
        var unitOfLength = $textbox.data('rocUnitOfLength');
        var uom = $textbox.val();
        if (unitOfLength && uom) {
            return uom.concat(unitOfLength);
        }

        return $textbox.val() || null;
    }

    var ProductUnitsOfMeasureHelper = {
        isUnitOfLength: isUnitOfLength,
        getUomIdFromTextBox: getUomIdFromTextBox,
        getBaseLengthUnitFromViewModel: getBaseLengthUnitFromViewModel
    }

    Logger.debug('ProductUnitsOfMeasureHelper.js Loaded:', ProductUnitsOfMeasureHelper);

    return ProductUnitsOfMeasureHelper;
});
